import { environment } from '@env/environment';
import { find, findIndex, remove, forEach } from 'lodash';
import { Static } from './../util/static';
import { DetalleVistaDinamica } from './../models/vistas-dinamicas.model';
import { Component, OnInit, Input, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { DynamicViewConfigService } from './shared/dynamic-view.config.service';
import { DynamicViewDataService } from './shared/dynamic-view.data.service';
import { ConfirmComponent } from '../confirm/confirm.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Usuario } from '../models/usuario.model';
import { ColumnsTableModalSelect } from '../models/modal-select.model';
import { FormGroup, FormControl } from '@angular/forms';
import { Const } from '../util/constants';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-dynamic-view',
  templateUrl: './dynamic-view.component.html',
  styleUrls: ['./dynamic-view.component.scss'],
  providers: [DynamicViewDataService]
})
export class DynamicViewComponent implements OnInit, OnDestroy {
  
  // Contiene la informacion de la vista dinamica
  @Input() view: DetalleVistaDinamica;
  // Mensaje de carga
  loadingMessage = '';
  // Contiene el id del grupo seleccionado
  rolId = -1;
  selectGroups: any[] = [];
  // Contiene el tramite de filtro eleccionado
  selectedTramite = -1;
  // Define cuando se esta cargando el calendario de actividades
  isLoading = false;
  // Determina cuando esta consultando los usuarios del grupo
  isLoadingUser = false;
  // Define cuando la vista es filtrada por los tramites
  filterTramite = false;
  // Define cuando mostrar la tabla de datos
  seeTable = true;
  // Define las acciones en la vista
  actionsView = {
    exportExcel: false,
    init: false,
    initAssignament: false,
  };
  // Filas seleccionadas de la tabla
  selectedRows: number[] = [];
  // Usuarios seleccionados para ser los responsables de la tarea
  responsibles: Usuario[] = [];
  // Usuarios del rol(grupo) seleccionado
  users: Usuario[];
  // Contiene los registros consultados de la tabla
  data: any[] = [];
  // Contiene la configuracion de columnas del selector con modal
  columnsSelect: ColumnsTableModalSelect[] = [
    {
      key: 'categoria',
      label: 'Categoría'
    },
    {
      key: 'proceso',
      label: 'Proceso'
    },
    {
      key: 'tramite',
      label: 'Trámite'
    },
  ];
  // Define cuando se muestra la carga de la tabla
  loaderTable = false;
  // Define cuando se muestra el boton de buscar
  SearchButton = false;
  // numero de registros de la tabla
  pageSize = 10;
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Datos para llenar la tabla dfe usuarios del grupo
  sourceUser: LocalDataSource = new LocalDataSource();
  // Configuración de la tabla
  settings = {};
  // contiene la configuracion de la tabla
  settingsUsers = {};
  // Formulario de seleccion de tramite de filtro
  form: FormGroup = new FormGroup({
    tramiteSelect: new FormControl()
  });
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Componente de confirmaciones
  @ViewChild(ConfirmComponent) private confirmRef: ConfirmComponent;
  // Template de la modal de asignaciones
  @ViewChild('modalAsignament') private modalAsignament: TemplateRef<any>;

  

  constructor(
    private dvds: DynamicViewDataService,
    private toastr: ToastrService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    if (this.view && this.view.id) {
      this.actionsPermissions();
      this.selectedRows = [];
      if (!this.view.filtro) {
        this.seeTable = true;
        this.loadStructureTable();
        this.loadDataSource();
        this.filterTramite = false;
      } else {
        this.seeTable = false;
        this.filterTramite = true;
        this.form.controls['tramiteSelect'].valueChanges.subscribe(select => {
          if (this.selectedTramite !== select) {
            this.loadTramitesSelected(select);
          }
        });
      }
      
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Carga de la informacion de la tabla
   *
   * @param {number} [idTramite]
   * @memberof DynamicViewComponent
   */
  loadDataSource(idTramite?: number) {
    this.loadingMessage = 'Cargando procesos pendientes para iniciar ' + this.view.tramite_destino.nombre + '...';
    this.selectedRows = [];
    this.isLoading = true;
    this.dvds.getDataTables(this.view.id, idTramite).subscribe(data => {
      this.data = Static.copyObjet(data);
      this.sourceData = new LocalDataSource(this.data);
      this.isLoading = false;
      this.loadingMessage = '';
    },
    _err => {
      this.isLoading = false;
      this.loadingMessage = '';
    });
  }

  /**
   * Confirmacion de exportar tabla a excel
   *
   * @memberof DynamicViewComponent
   */
  comfirmExpotExcel() {
    this.confirmRef.new({
      question: '¿Exportar tabla a excel?',
      labelConfirm: 'Sí',
      labelDecline: 'No'
    }).then(resp => {
      if (resp) {
        this.exportExcel();
      }
    });
  }

  /**
   * Controla la seleccion de registros en la tabla de procesos
   *
   * @param {*} data
   * @memberof DynamicViewComponent
   */
  userRowSelect(data: any) {
    if(data){
    const existSelect = this.selectedRows.indexOf(data['data']['id']);
    if (existSelect > -1 && !data.isSelected) {
      this.selectedRows.splice(existSelect, 1);
    } else if(existSelect == -1 && data.isSelected) {
      this.selectedRows.push(data['data']['id']);
    }
    }
  }

  /**
   * Confirmacion para iniciar procesos de destino
   *
   * @param {boolean} [assignament=false]
   * @memberof DynamicViewComponent
   */
  confirmInitProcess(assignament: boolean = false) {
    if (this.selectedRows.length) {
      let message = '';
      if (assignament){
        let resultGroups: any[]= [];
          this.selectGroups.forEach((data, i) => {
            if (resultGroups.indexOf(data.rol) === -1){
              resultGroups.push(data.rol);
            }
          });
        let groups = '';
        if(this.view.tramite_destino.roles){
          resultGroups.forEach((data, i) => {
            let group = ''
            if (i === 0) {
              forEach(this.view.tramite_destino.roles,(rol: { id: any; nombre: any; })=>{
                if(rol.id == data){
                  group = rol.nombre;
                }
              });
              groups = group;
            } else {
              forEach(this.view.tramite_destino.roles,(rol: { id: any; nombre: any; })=>{
                if(rol.id == data){
                  group = rol.nombre;
                }
              });
              groups = groups + ', ' + group;
            }
          });
        }
        if (resultGroups.length > 1) {
          message = '¿Esta seguro de asignar a los grupos '+ groups + ' seleccionados?';
        } else if(resultGroups.length == 1){
          message = '¿Esta seguro de asignar al ' +
                      groups +
                    ' seleccionado?';

        } else {
          this.toastr.warning('Debe seleccionar al menos un usuario', 'Información incompleta.');
          return;
        }
      }else{
        if (this.selectedRows.length > 1) {
          message = '¿Esta seguro de iniciar los tramites de ' +
                    this.view.tramite_destino.nombre +
                    ' basados en los tramites seleccionados?';
        } else {
          message = '¿Esta seguro de iniciar el trámite de ' +
                    this.view.tramite_destino.nombre +
                    ' basado en el trámite seleccionado?';
        }
      }
      
      this.confirmRef.new({
        question: message,
        labelConfirm: 'Sí',
        labelDecline: 'No'
      }).then(resp => {
        if (resp) {
          this.sourceUser.empty();
          this.SearchButton = false;
          this.initProcess(assignament);
        }
      });
    } else {
      this.toastr.warning('Debe seleccionar al menos un trámite de origen.', 'Información incompleta.');
    }
  }

  /**
   * Validacion para abrir modal de asignaciones
   *
   * @param {TemplateRef<any>} template
   * @param {boolean} [ignoreBackdropClick=true]
   * @param {string} [classModal='modal-lg']
   * @memberof DynamicViewComponent
   */
  openConfirmModalAssignament(
    template: TemplateRef<any>,
    ignoreBackdropClick: boolean = true,
    classModal: string = 'modal-lg'
  ) {
    if (this.selectedRows.length) {
      this.openModal(template, ignoreBackdropClick, classModal);
    } else {
      this.toastr.warning('Debe seleccionar al menos un trámite de origen.', 'Información incompleta.');
    }
  }

  /**
   * Abrir una modal en el componente
   *
   * @param {TemplateRef<any>} template
   * @param {boolean} [ignoreBackdropClick=true]
   * @param {string} [classModal='modal-lg']
   * @memberof DynamicViewComponent
   */
  openModal(template: TemplateRef<any>, ignoreBackdropClick: boolean = true, classModal: string = 'modal-lg') {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: classModal, ignoreBackdropClick: ignoreBackdropClick })
    );
  }

  /**
   * Consulta los usuarios del rol(grupo) seleccionado.
   *
   * @param {number} idRole
   * @memberof DynamicViewComponent
   */
  chooseRole(idRole: number) {
    if (this.rolId !== idRole) {
      this.rolId = idRole;
      this.isLoadingUser = true;
      this.sourceUser.empty();
      this.dvds.getRole(idRole).then(async r => {
        if (r.rol_user && r.rol_user.length) {
          r.rol_user.forEach((user, i) => {
            r.rol_user[i]['select'] = this.isAssigned(user);
            r.rol_user[i]['nombre'] = user.first_name + ' ' + user.last_name;
          });
        }
        this.users = r.rol_user;
        this.sourceUser = new LocalDataSource(this.users);
        this.sourceUser.onChanged().subscribe(async (change: { action: string; filter: { filters: string | any[]; }; paging: { page: any; }; }) => {
          if (change.action === 'page' && this.sourceUser['data'].length) {
            let checkFilter = false;
            if (change.filter.filters.length){
              forEach(change.filter.filters,f=>{
                if(f.search !=""){
                  checkFilter = true;
                }
              })
            }
            if (!checkFilter){
              this.pageChange(change.paging.page);
            }
            
          }else if(change.action === 'filter' && this.sourceUser['data'].length && change.filter.filters.length){
            let checkFilter = false;
            forEach(change.filter.filters,f=>{
              if(f.search !=""){
                checkFilter = true;
              }
            })
            if(checkFilter){
              this.SearchButton = true;
            }else{
              this.SearchButton = false;
              if (this.rolId){
                this.loaderTable = true;
                this.dvds.getRole(this.rolId)
                .then(async data => {
                  if (data.rol_user && data.rol_user.length) {
                    data.rol_user.forEach((user, i) => {
                      data.rol_user[i]['select'] = this.isAssigned(user);
                      data.rol_user[i]['nombre'] = user.first_name + ' ' + user.last_name;
                    });
                  }
                  this.users = r.rol_user;
                  if (this.sourceUser.count() > 0){
                    this.sourceUser.empty();
                    // Reload the data
                    this.sourceUser.load(this.users);
  
                    // Refresh the data source
                    //this.sourceUser.refresh();
                    this.loaderTable = false;
                }
                  else{
                    this.sourceUser.load(this.users);
                    this.loaderTable = false;
                  }
                });
              }
              
                  
            }
          }
        });
        this.sourceUser.refresh();
        this.isLoadingUser = false;
      });
    }
  }

  /**
   * Asigna un usuario como responsable.
   *
   * @param {*} user
   * @memberof DynamicViewComponent
   */
  chooseUser(user: any) {
    const userIndex = findIndex(this.users, {id: user.data.id});
    // Eliminar responable si existe
    const removed = remove(this.responsibles, u => {
      return u.id === user.data.id;
    });
    if (!removed.length) {
      this.responsibles.push(user.data);
      if (userIndex !== -1) {
        this.users[userIndex]['select'] = true;
        this.sourceUser.update(user.data, this.users[userIndex]);
      }
      this.selectGroups.push({rol:this.rolId, user:user.data.id});
    } else {
      if (userIndex !== -1) {
        this.users[userIndex]['select'] = false;
        this.sourceUser.update(user.data, this.users[userIndex]);
        // Find the index of 'two'
        let validRemoveGroup = this.selectGroups.find((group: { rol: number; user: number; }) => group.user === user.data.id);
        if(validRemoveGroup){
          const indexToRemove = this.selectGroups.indexOf(validRemoveGroup);
        if (indexToRemove > -1) {
          this.selectGroups.splice(indexToRemove, 1); // Remove the item
        }
        }
        
      }
    }
  }

  /**
   * Cierra la modal de asignaciones
   *
   * @memberof DynamicViewComponent
   */
  closeModalAssignament() {
    this.responsibles = [];
    this.users = undefined;
    this.SearchButton = false;
    this.sourceUser = new LocalDataSource();
    this.modalRef.hide();
    this.rolId = -1;
    this.selectGroups = [];
  }

  /**
   * Carga de estructura de la tabla de la vista
   *
   * @private
   * @param {number} [idTramite]
   * @memberof DynamicViewComponent
   */
  private loadStructureTable(idTramite?: number) {
    const configTable = new DynamicViewConfigService();
    this.settingsUsers = configTable.getSettingsTableAssignment();
    if (this.view.estructura.length) {
      this.view.estructura.sort((a, b) => a.orden - b.orden);
      this.view.estructura.forEach(structure => {
        let valid = true;
        if (idTramite) {
          const indexExist = structure.tramites.indexOf(idTramite);
          if (indexExist === -1) {
            valid = false;
          }
        }
        if (valid) {
          configTable.generateColumn(structure.id + ' ', structure.nombre);
        }
      });
    }
    this.settings = configTable.settings;
  }

  /**
   * Carga los registros y columnas de la tabla configuradas para el tramite seleccionado
   *
   * @private
   * @param {number} select
   * @memberof DynamicViewComponent
   */
  private loadTramitesSelected(select: number) {
    this.selectedRows = [];
    if (select) {
      this.seeTable = true;
      this.loadStructureTable(select);
      this.loadDataSource(select);
    } else {
      const configTable = new DynamicViewConfigService();
      this.settings = configTable.settings;
      this.seeTable = false;
      this.data = [];
      this.sourceData = undefined;
    }
  }

  /**
   * Iniciar instancia de proceso de destino basado en procesos seleccionados
   *
   * @private
   * @param {boolean} [assignament=false]
   * @memberof DynamicViewComponent
   */
  private initProcess(assignament: boolean = false) {
    if (this.selectedRows.length > 1) {
      this.loadingMessage = 'Iniciando procesos de ' + this.view.tramite_destino.nombre;
    } else {
      this.loadingMessage = 'Iniciando proceso de ' + this.view.tramite_destino.nombre;
    }
    if (assignament) {
      const idsResponsibles: number[] = [];
      if (this.responsibles && this.responsibles.length) {
        this.isLoading = true;
        this.modalRef.hide();
        this.responsibles.forEach(responsible => {
          idsResponsibles.push(responsible.id);
        });
        if (environment.vistasDinamicas) {
          this.dvds.initProcessAsignament(this.view.id, this.selectedRows, idsResponsibles).subscribe(_res => {
            this.closeModalAssignament();
            this.isLoading = false;
            this.loadingMessage = '';
            this.selectGroups = [];
            if (!this.view.filtro) {
            this.loadDataSource();
            }else{
              this.loadDataSource(this.form.controls['tramiteSelect'].value);
            }
          },
          _err => {
            this.isLoading = false;
            this.loadingMessage = '';
            this.openModal(this.modalAsignament, true, 'modal-lg-personalized');
          });
        } else {
          this.isLoading = false;
          this.loadingMessage = '';
          this.openModal(this.modalAsignament, true, 'modal-lg-personalized');
        }
      } else {
        this.toastr.warning('Debe seleccionar al menos un usuario.', 'Información incompleta');
      }
    } else {
      this.selectGroups = [];
      this.isLoading = true;
      if (environment.vistasDinamicas) {
        this.dvds.initProcess(this.view.id, this.selectedRows).subscribe(_ressponse => {
          this.isLoading = false;
          this.loadingMessage = '';
          if (!this.view.filtro) {
            this.loadDataSource();
            }else{
              this.loadDataSource(this.form.controls['tramiteSelect'].value);
            }
        },
        _err => {
          this.isLoading = false;
          this.loadingMessage = '';
        });
      } else {
        this.isLoading = false;
      }
    }
  }

  /**
   * Funcion de exportar tabla a excel
   *
   * @private
   * @memberof DynamicViewComponent
   */
  private exportExcel() {
    this.sourceData.getFilteredAndSorted().then(data => {
      if (environment.vistasDinamicas) {
        this.dvds.generateReport(this.view.id, data).subscribe(res => {
          const a = document.createElement('a');
          a.target = '_blank';
          a.href = res.path;
          a.download = res.name;
          a.click();
          a.remove();
        });
      }
    });
  }

  /**
   * Valida si un usuario esta asignado.
   *
   * @private
   * @param {Usuario} user
   * @returns {boolean}
   * @memberof DynamicViewComponent
   */
  private isAssigned(user: Usuario): boolean {
    const userResponsible = find(this.responsibles, { id: user.id });
    if (userResponsible) {
      return true;
    }
    return false;
  }

  /**
   * Define los permisos de acciones asignados al rol del usuario actualmente loguedo para esta pestaña
   *
   * @private
   * @memberof DynamicViewComponent
   */
  private actionsPermissions() {
    if (this.view.acciones.length) {
      this.view.acciones.forEach(action => {
        switch (action.nombre) {
          case Const.DYNAMIC_VIEW_ACTIONS.generarReporte:
            this.actionsView.exportExcel = true;
            break;
          case Const.DYNAMIC_VIEW_ACTIONS.iniciarAsignandoResponsables:
            this.actionsView.initAssignament = true;
            break;
          case Const.DYNAMIC_VIEW_ACTIONS.iniciarTramite:
            this.actionsView.init = true;
            break;
        }
      });
    }
  }


  pageChange(pageIndex:any) {
    let loadedRecordCount = this.sourceUser.count();
    let lastRequestedRecordIndex = pageIndex * this.pageSize;
  
    if (loadedRecordCount <= lastRequestedRecordIndex) {    
      let startIndex =  loadedRecordCount + 1;
      let recordCount = lastRequestedRecordIndex + 50; //extra 100 records improves UX.

      this.loaderTable = true;
        this.dvds.getRole(this.rolId,startIndex,recordCount) //.toPromise()
        .then(async data => {
          if (data.rol_user && data.rol_user.length) {
            data.rol_user.forEach((user, i) => {
              data.rol_user[i]['select'] = this.isAssigned(user);
              data.rol_user[i]['nombre'] = user.first_name + ' ' + user.last_name;
            });
          }
          if (this.sourceUser.count() > 0){
            //this.sourceUser.empty();
            data.rol_user.forEach(user => {
              this.sourceUser.add(user);
            });
            const allData = await this.sourceUser.getAll();
            this.sourceUser.load(allData);
            this.loaderTable = false;
            this.loaderTable = false;
        }
          else{
            this.sourceUser.load(data.rol_user);
          }
        });
    }
  }

   /**
   * Esta funcion se ejecuta para filtar datos de tablas
   *
   * @param {Any} source
   * @memberof DynamicViewComponent
   */
   filterData(source: any) {
    if(source.filterConf && source.filterConf.filters.length){
      let filterFields: any[] = []
      forEach(source.filterConf.filters, (fil:any)=>{
        if(fil.search != ""){filterFields.push({"column":fil.field,"valor":fil.search})}
      })
      if (filterFields.length){
        this.loaderTable = true;

      this.dvds.getRole(this.rolId,0,50,filterFields)
      .then(async data => {
        if (data.rol_user && data.rol_user.length) {
          data.rol_user.forEach((user, i) => {
            data.rol_user[i]['select'] = this.isAssigned(user);
            data.rol_user[i]['nombre'] = user.first_name + ' ' + user.last_name;
          });
        }
        // Store the current filters
          //const currentFilters = this.sourceUser.getFilter();
          this.sourceUser.empty();
          // Reload the data
          this.sourceUser.load(data.rol_user);

          this.loaderTable = false;
      })
      }else{
        this.loaderTable = true;
        this.dvds.getRole(this.rolId)
        .then(async data => {
          if (data.rol_user && data.rol_user.length) {
            data.rol_user.forEach((user, i) => {
              data.rol_user[i]['select'] = this.isAssigned(user);
              data.rol_user[i]['nombre'] = user.first_name + ' ' + user.last_name;
            });
          }
          if (this.sourceUser.count() > 0){
            this.sourceUser.empty();
            // Reload the data
            this.sourceUser.load(data.rol_user);

            // Refresh the data source
            //this.sourceUser.refresh();
            this.loaderTable = false;
        }
          else{
            this.sourceUser.load(data.rol_user);
            this.loaderTable = false;
          }
        })
      }
      
    }else{
      this.loaderTable = true;
      this.dvds.getRole(this.rolId) //.toPromise()
      .then(async data => {
        if (data.rol_user && data.rol_user.length) {
          data.rol_user.forEach((user, i) => {
            data.rol_user[i]['select'] = this.isAssigned(user);
            data.rol_user[i]['nombre'] = user.first_name + ' ' + user.last_name;
          });
        }
        if (this.sourceUser.count() > 0){
          this.sourceUser.empty();
          // Reload the data
          this.sourceUser.load(data.rol_user);
          this.loaderTable = false;

          // Refresh the data source
          //this.sourceUser.refresh();
      }
        else{
          this.loaderTable = false;
          this.sourceUser.load(data.rol_user);
        }
      })
    }  
  }


}




// WEBPACK FOOTER //
// ./src/app/shared/dynamic-view/dynamic-view.component.ts